export default __webpack_public_path__ + "static/media/baixarfranquia1.d8c33ec2.png";